<template>
  <div
    class="data-table__body__rows"
    :class="{ 'clickable-row': !alert.dateRead }"
    @click="handleRowClick"
  >
    <DataCell :size="15">
      <h3>{{ displayValue('numberAlvaroOrder') }}</h3>
    </DataCell>

    <DataCell :size="15">
      <p>{{ displayValue('patientName') }}</p>
    </DataCell>

    <DataCell :size="15">
      <p>{{ displayValue('examCode') }}</p>
    </DataCell>

    <DataCell :size="15">
      <p>{{ formatDate(displayValue('dateResult')) }}</p>
    </DataCell>

    <DataCell :size="30">
      <div v-if="alert.dateRead">
        <p>
          O exame apresenta <strong class="exame-result">resultado crítico</strong>. Indicamos informar o médico responsável
          pela solicitação do exame. Para mais detalhes, entre em contato com
          o <strong>Conexão Álvaro no 0800 643 8100</strong>, horário de atendimento das <strong>7:00 às 19:00</strong>.
        </p>
      </div>
      <div v-else>
        <span> ************************************************ </span>
      </div>
    </DataCell>

    <DataCell
      :size="10"
      class="action"
      @click.stop
    >
      <div
        v-if="!alert.dateRead"
        class="data-showoff"
      >
        <div @click="emitRead(alert.id, index)">
          <md-icon md-src="/static/images/icon-eye-off.svg" />
        </div>
      </div>
      <div
        v-if="alert.dateRead"
      >
        <button
          v-if="!loading"
          class="btn btn-primary"
          @click="emitDownload(alert.numberAlvaroOrder, index)"
        >
          <md-icon md-src="/static/images/icon-eye-alt.svg" />
          <md-tooltip md-delay="200">
            Visualizar laudo
          </md-tooltip>
        </button>
        <Spinner
          v-else
          class="spinner small"
        />
      </div>
    </DataCell>

    <div
      v-show="alert.dateRead"
      class="read-status-custom"
    >
      <ReadStatus :read-at="alert.dateRead ?? ''" />
    </div>
    <md-tooltip
      v-if="!alert.dateRead"
      md-direction="bottom"
      md-delay="200"
    >
      Clique aqui para visualizar o paciente
    </md-tooltip>
  </div>
</template>

<script>
import DataCell from '@/components/common/dataTable/DataCell.vue'
import ReadStatus from '@/components/common/ReadStatus.vue'
import Spinner from '@/components/common/Spinner.vue'
import Moment from 'moment'

export default {
  name: 'PanicAlertRow',
  components: {
    DataCell,
    ReadStatus,
    Spinner
  },
  props: {
    alert: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['read', 'download'],
  methods: {
    displayValue(key) {
      return this.alert.dateRead && key ? this.alert[key] : '***********'
    },
    formatDate(date) {
      return date && Moment(date).isValid()
        ? Moment.utc(date).format('DD/MM/YYYY')
        : date
    },
    emitRead(id, index) {
      this.$emit('read', id, index)
    },
    emitDownload(order, index) {
      this.$emit('download', order, index)
    },
    handleRowClick() {
      if (!this.alert.dateRead) {
        this.emitRead(this.alert.id, this.index)
      }
    }
  }

}
</script>

<style scoped lang="scss">
@import '../../../static/stylesheets/variables';

.data-table__body__rows {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  background: white;
  border-radius: 3px;
  padding: 0;
  margin: 0 0 1em 0;
  font-family: Roboto, "Noto Sans", Noto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: rgba(0, 0, 0, 0.87);
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.2s;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

.clickable-row:hover {
  background-color: #f1f1f1;
}

.spinner {
  margin: 1px 8px 0 0;
}

.btn {
  min-width: 40px;
  max-width: 40px;
  height: 40px;
  border-radius: 8px;
  padding: 8px !important;
  margin-right: 6px;
}

.action {
  min-width: 66px;
  margin: 0;
  display: flex;
  justify-content: flex-end;
}

.read-status-custom {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 16px;
  margin-top: -8px;
}

.data-showoff {
  display: flex;
  align-items: center;
  gap: 16px;

  .md-icon {
    color: #808080 !important;
    cursor: pointer;
    transition: color 0.3s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }
}

p {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 26px;
  color: #4a4a4a;
  font-weight: normal;
  font-style: normal;
}

.patient {
  font-weight: bold;
  color: $jaffa;
}

.exame-result {
  color: red;
}
</style>
